import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { CardHeader } from '@/shared/ui/core';
import styles from './registration-card.module.scss';


export function RegistrationCardHeader ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <CardHeader
            className={ cn(styles.header, className) }
            data-template="registration-card-header"
            { ...props }
        />
    );
}
